// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1F0pZ","name":"Header_name__3NJWw","birthday":"Header_birthday__2Nh0r","skeleton":"Header_skeleton__3UFBN"};